import React, {useMemo} from "react";
import {AuthFramePageFooterLink, useTheme} from "peggirkit";
import {MoonIcon, SunIcon} from "@heroicons/react/16/solid";
import {FormattedMessage} from "react-intl";

const ThemeToggle = () => {
    const {isDark, toggleTheme} = useTheme();
    const Icon = useMemo(() => isDark ? SunIcon : MoonIcon, [isDark]);

    return (
        <AuthFramePageFooterLink
            action={{
                as: "button",
                actionProps: {onClick: toggleTheme},
            }}
        >
            <Icon className={"inline w-[18px] h-[18px] mr-1"}/>
            <FormattedMessage id={isDark ? "lightMode" : "darkMode"}/>
        </AuthFramePageFooterLink>
    );
};

export default ThemeToggle;